import { AtomicProductV2 } from "./atomic-productv2.model";
import { ProductV2 } from "./productv2.model";

export class ProductWithChildrenV2 extends AtomicProductV2 {
        children: ProductV2[];
}